import { render, staticRenderFns } from "./explore-trip-info.vue?vue&type=template&id=58a5eeec&scoped=true"
import script from "./explore-trip-info.vue?vue&type=script&lang=js"
export * from "./explore-trip-info.vue?vue&type=script&lang=js"
import style0 from "./explore-trip-info.vue?vue&type=style&index=0&id=58a5eeec&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58a5eeec",
  null
  
)

export default component.exports